import _asyncToGenerator from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _extends from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _useSetState3 from "ahooks/lib/useSetState";
import _slicedToArray from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import GloBar from "../app/eflayout/GloBar";
import GAGlobal from "../appComps/GAGlobal";
import UserHasAction from "../appComps/UserHasAction";
import { getDeployPageType } from "../components/PageLayout/widgets/utils/getDeployPageType";
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { DefaultSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Helmet } from 'react-helmet';
import SeoConfig from "../../next-seo.config";
import { LocalesLangDetail } from "../appSetting/setting-data/LocalesLangDetail";
import LoginFormModal from "../components/LoginFormModal";
import WidgetsA from "../components/PageLayout/widgets";
import Link from "../components/utils/Link";
import SEO from "../components/utils/SEO";
import { getAllLocaleMessage, I18nProvider, useLang as _useLang } from "../i18n";
import { IS_EDIT_MODE } from "../i18n/editLang";
import { browserIsInApp, browserIsMobile, isReadyLang } from "../utils";
import { updateLocalAppInfo } from "../utils/common";
import gtm from "../utils/gtm";
import getDefaultHeader from "../utils/singUtil/getDefaultHeader";
import getHostApi from "../utils/singUtil/getHostApi";
import { GlobalContext } from "../utils/useGlobal";
import { useStore } from "../utils/useStore";
var getOnlineEditorData = function getOnlineEditorData(data) {
  var ret = {
    thePage: {},
    theTemp: [],
    theData: {},
    theAttr: {}
  };
  try {
    ret.thePage = JSON.parse((data === null || data === void 0 ? void 0 : data.thePage) || '{}');
    ret.theTemp = JSON.parse((data === null || data === void 0 ? void 0 : data.theTemp) || '[]');
    ret.theData = JSON.parse((data === null || data === void 0 ? void 0 : data.theData) || '{}');
    ret.theAttr = JSON.parse((data === null || data === void 0 ? void 0 : data.theAttr) || '{}');
  } catch (error) {}
  return ret;
};
var isLangEditTest = process.env.NEXT_PUBLIC_LANG_EDIT === 'on';
var cdnUrl = process.env.NEXT_PUBLIC_CDN_URL;
var openOneTrustCookie = process.env.NEXT_PUBLIC_ONETRUST_OPEN === 'on';
var openVConsole = process.env.NEXT_PUBLIC_VCONSOLE_OPEN === 'on';
var Vconsole = dynamic(function () {
  return import("../components/VConsole");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@/components/VConsole")];
    }
  }
});
var isCypressTestFn = function isCypressTestFn() {
  if (typeof window !== 'undefined') {
    var _window, _window$navigator;
    var _userAgent2 = ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) || '';
    var _devices2 = _userAgent2.toLowerCase() || '';
    if (_devices2.indexOf('iscypresstest') > 0) {
      return true;
    }
  }
  return false;
};
var isprodiuct0426 = false;
// 是否不是app的某个页面
var isNotAppThePageFn = function isNotAppThePageFn(isApp, pathname) {
  var allowPathname = ['/delta-pro-3-portable-power-station'];
  if (isApp && allowPathname.includes(pathname)) {
    return false;
  }
  return true;
};
var NEXT_PUBLIC_MODY = process.env.NEXT_PUBLIC_MODY;
var NEXT_IS_PRD = NEXT_PUBLIC_MODY === 'prd' || NEXT_PUBLIC_MODY === 'staging' || NEXT_PUBLIC_MODY === 'uat';
var removeGloproductlistArray = ['/', '/devtest1',
// '/stream-series-plug-in-solar-battery',
'/delta-pro-ultra-x', '/stream-balcony-solar-system', '/oasis-home-energy-management-system', '/stream-microinverter', '/delta-3-max-plus-portable-power-station', '/on-the-road-power-solution']; //去掉全局列表的页面
export default function EFApp(_ref) {
  var _globalLangAll$langOb;
  var Component = _ref.Component,
    pageProps = _ref.pageProps,
    seoMap = _ref.seoMap,
    spuList = _ref.spuList,
    headerList = _ref.headerList,
    bottomList = _ref.bottomList,
    isMobileServer = _ref.isMobileServer,
    categoryList = _ref.categoryList,
    globalLangAll = _ref.globalLangAll,
    isSupportWebp = _ref.isSupportWebp,
    navigationBarResponseList = _ref.navigationBarResponseList,
    globalTimestamp = _ref.globalTimestamp,
    gloproductlist = _ref.gloproductlist,
    hostname2 = _ref.hostname2,
    __inwebsite__ = _ref.__inwebsite__,
    gloBarObject = _ref.gloBarObject,
    isBlogPage = _ref.isBlogPage,
    textIdA1 = _ref.textIdA1,
    __globar_object = _ref.__globar_object;
  var isMobile = typeof window === 'undefined' ? isMobileServer : browserIsMobile(navigator.userAgent);
  var isApp = typeof window === 'undefined' ? false : browserIsInApp(navigator.userAgent);
  // const firstRenderRef = useRef(false);
  var _loadLangTextFail = globalLangAll === null || globalLangAll === void 0 ? void 0 : (_globalLangAll$langOb = globalLangAll.langObj) === null || _globalLangAll$langOb === void 0 ? void 0 : _globalLangAll$langOb._loadLangTextFail; //是否读取方文案失败,用于cypress检测
  var router = useRouter();
  var locale = router.locale,
    pathname = router.pathname;
  var _useState = useState(false),
    showLoginModal = _useState[0],
    setShowLoginModal = _useState[1];
  var _useState2 = useState(false),
    isClient = _useState2[0],
    setIsClient = _useState2[1];
  useEffect(function () {
    setIsClient(true);
    EcoDesignEventsBus.on('GlobalLoginRegisterA-open', function (visible) {
      setShowLoginModal(visible);
    });
  }, []);

  // 是否是自动化脚本
  var isCypressTest = isCypressTestFn();
  var timeOffset = new Date().getTime() - globalTimestamp;
  var htmlLangValue = LocalesLangDetail[locale];
  var getSystemTime = function getSystemTime() {
    return new Date().getTime() - timeOffset;
  };
  var setGlobalContext = function setGlobalContext(data) {
    setGlobalProps(data);
  };
  var _useSetState = _useSetState3({
      isLangEditTest: isLangEditTest,
      Link: Link,
      //Image,
      useRouter: useRouter,
      useState: useState,
      useEffect: useEffect,
      useStore: useStore,
      useLang: function useLang(key) {
        return _useLang(key, false, globalLangAll);
      },
      useRef: useRef,
      spuList: spuList,
      headerList: headerList,
      bottomList: bottomList,
      isMobile: isMobile,
      isSupportWebp: isSupportWebp,
      seoMap: seoMap || [],
      gtm: gtm,
      categoryList: categoryList,
      navigationBarResponseList: navigationBarResponseList,
      IS_EDIT_MODE: IS_EDIT_MODE,
      IS_EDIT_PREVIEW: false,
      globalTimestamp: globalTimestamp,
      getSystemTime: getSystemTime,
      isCypressTest: isCypressTest,
      gloproductlist: gloproductlist,
      subEmailCount: 0,
      setGlobalContext: setGlobalContext,
      isApp: isApp,
      gloBarObject: gloBarObject,
      textIdA1: textIdA1
    }),
    _useSetState2 = _slicedToArray(_useSetState, 2),
    globalProps = _useSetState2[0],
    setGlobalProps = _useSetState2[1];

  // 在浏览器执行初始化
  var initInBrowser = function initInBrowser() {
    updateLocalAppInfo(locale);
  };

  //进入浏览器,执行初始化
  if (typeof window !== 'undefined') {
    initInBrowser();
  }
  var isTempedit = pathname.indexOf('/tempedit') > -1 || pathname.indexOf('/edit-blog') > -1;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, {
    htmlAttributes: {
      lang: htmlLangValue,
      site: locale,
      dir: locale === 'sa' ? 'rtl' : 'ltr'
    }
  }, /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: "https://websiteoss.ecoflow.com",
    crossOrigin: "true"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    href: "https://websiteoss.ecoflow.com/00a6c4ae89c5e7992703744efb44a917.ico"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    href: "https://websiteoss.ecoflow.com/e12981ae13b758cae5b5068362d376e4.png"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "apple-mobile-web-app-capable",
    content: "no"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "apple-mobile-web-app-status-bar-style",
    content: "default"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "apple-mobile-web-app-title",
    content: "Ecoflow"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "msapplication-TileColor",
    content: "#ffffff"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "theme-color",
    content: "#ffffff"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "referrer",
    content: "strict-origin-when-cross-origin"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1, viewport-fit=cover, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
  }), /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    defer: true
  }, JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'EcoFlow',
    url: 'https://www.ecoflow.com/us'
  })), /*#__PURE__*/React.createElement("meta", {
    property: "og:site_name",
    content: "EcoFlow"
  }), /*#__PURE__*/React.createElement("body", {
    className: "".concat(isMobile ? 'ecoflow-mobile' : 'ecoflow-pc').concat(isApp ? ' ecoflow-app' : '').concat(__inwebsite__ ? ' __inwebsite__' : '').concat(_loadLangTextFail ? ' _loadLangTextFail' : '')
  })), /*#__PURE__*/React.createElement(I18nProvider, {
    globalLangAll: globalLangAll,
    isMobile: isMobile,
    isLangEditTest: isLangEditTest,
    isEditPreview: globalProps.IS_EDIT_PREVIEW,
    locale: locale
  }, function (_ref2) {
    var componentWords = _ref2.componentWords;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !isBlogPage && /*#__PURE__*/React.createElement(DefaultSeo, SeoConfig[locale]), /*#__PURE__*/React.createElement(GlobalContext.Provider, {
      value: globalProps
    }, /*#__PURE__*/React.createElement(Component, _extends({}, pageProps, {
      lang: componentWords,
      SEO: !!isBlogPage ? null : SEO
    }, globalProps)), openVConsole && isApp && /*#__PURE__*/React.createElement(Vconsole, null), isClient && showLoginModal && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(LoginFormModal, {
      visible: showLoginModal,
      onCancel: function onCancel() {
        setShowLoginModal(false);
      },
      type: "passwordless"
    }), document.body)), /*#__PURE__*/React.createElement(UserHasAction, null), /*#__PURE__*/React.createElement(GAGlobal, null), /*#__PURE__*/React.createElement(WidgetsA, {
      globalTimestamp: globalTimestamp,
      __globar_object: __globar_object
    }));
  }), !isTempedit && !isBlogPage && /*#__PURE__*/React.createElement(GloBar, {
    gloBarObject: gloBarObject
  }));
}

// umi-request 不兼容 getInitialProps，所以封装了基于 fetch 的 efFetch
export var getInitialProps = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
    var _req$headers, _req$headers2, _req$referer, _fetchRes, _fetchRes2;
    var ctx, req, locale, pathname, query, userAgent, accept, hostname2, hostname1, httpType, hostname, isSupportWebp, isMobileServer, __inwebsite__, apiObj, isBlogPage, gloBarObject, fetchRes, headerList, bottomList, globalLangAll, textIdA1, __globar_object, _fetchResData2, _headers2, _allObjRes2, _allObjData2, _allObjData4, _navigationBar2, _deployPageType2, _allObjRes4, _allObjData6, _ctx$req$connection, _ctx$req$socket, _idA2, _idA4, _idA6;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ctx = _ref3.ctx;
            req = ctx.req, locale = ctx.locale, pathname = ctx.pathname, query = ctx.query;
            userAgent = req ? req.headers['user-agent'] : navigator.userAgent;
            accept = (req === null || req === void 0 ? void 0 : (_req$headers = req.headers) === null || _req$headers === void 0 ? void 0 : _req$headers.accept) || '';
            hostname2 = (req === null || req === void 0 ? void 0 : (_req$headers2 = req.headers) === null || _req$headers2 === void 0 ? void 0 : _req$headers2.host) || '';
            hostname1 = (req === null || req === void 0 ? void 0 : (_req$referer = req.referer) === null || _req$referer === void 0 ? void 0 : _req$referer.referer) || '';
            httpType = hostname1.indexOf('http:') > -1 ? 'http' : 'http';
            hostname = hostname2 ? "".concat(httpType, "://").concat(hostname2) : '';
            isSupportWebp = accept.includes('image/webp');
            isMobileServer = browserIsMobile(userAgent);
            __inwebsite__ = query.__inwebsite__ === '1';
            apiObj = getHostApi(locale);
            isBlogPage = (pathname || '').includes('/blog');
            gloBarObject = {
              __globar_top: {},
              __globar_win: {},
              __globar_left: {},
              __globar_right: {}
            };
            fetchRes = {};
            headerList = null;
            bottomList = null;
            globalLangAll = {
              langSharedObj: {},
              langObj: {}
            };
            textIdA1 = '';
            __globar_object = {};
            if (!(locale !== 'en' && isReadyLang(locale))) {
              _context.next = 74;
              break;
            }
            if (!(hostname && !removeGloproductlistArray.includes(pathname) && !isBlogPage)) {
              _context.next = 33;
              break;
            }
            _context.prev = 22;
            _context.next = 25;
            return fetch("".concat(hostname, "/api/getappglodata?locale=").concat(locale));
          case 25:
            _fetchResData2 = _context.sent;
            _context.next = 28;
            return _fetchResData2.json();
          case 28:
            fetchRes = _context.sent;
            _context.next = 33;
            break;
          case 31:
            _context.prev = 31;
            _context.t0 = _context["catch"](22);
          case 33:
            _context.prev = 33;
            _context.next = 36;
            return getAllLocaleMessage(pathname, locale, false);
          case 36:
            globalLangAll = _context.sent;
            _context.next = 41;
            break;
          case 39:
            _context.prev = 39;
            _context.t1 = _context["catch"](33);
          case 41:
            _headers2 = getDefaultHeader(locale);
            _context.prev = 42;
            _context.next = 45;
            return fetch("".concat(apiObj.NEXT_PUBLIC_API_HOST, "/componentPageIntegration?locale=").concat(locale), {
              headers: _headers2
            });
          case 45:
            _allObjRes2 = _context.sent;
            _context.next = 48;
            return _allObjRes2.json();
          case 48:
            _allObjData2 = _context.sent;
            _allObjData4 = _allObjData2.data || {};
            gloBarObject.__globar_top = getOnlineEditorData(_allObjData4.__globar_top);
            gloBarObject.__globar_win = getOnlineEditorData(_allObjData4.__globar_win);
            gloBarObject.__globar_left = getOnlineEditorData(_allObjData4.__globar_left);
            gloBarObject.__globar_right = getOnlineEditorData(_allObjData4.__globar_right);
            _navigationBar2 = _allObjData4.navigationBar || [];
            headerList = _navigationBar2.find(function (item) {
              return item.configCode === 'topNavigation';
            });
            bottomList = _navigationBar2.find(function (item) {
              return item.configCode === 'bottomNavigation';
            });
            _context.next = 61;
            break;
          case 59:
            _context.prev = 59;
            _context.t2 = _context["catch"](42);
          case 61:
            _context.prev = 61;
            _deployPageType2 = getDeployPageType(pathname || '');
            _context.next = 65;
            return fetch("".concat(apiObj.NEXT_PUBLIC_API_HOST, "/widgetConfigIntegration"), {
              headers: _headers2
            });
          case 65:
            _allObjRes4 = _context.sent;
            _context.next = 68;
            return _allObjRes4.json();
          case 68:
            _allObjData6 = _context.sent;
            __globar_object = _allObjData6.data || {};
            _context.next = 74;
            break;
          case 72:
            _context.prev = 72;
            _context.t3 = _context["catch"](61);
          case 74:
            try {
              _idA2 = ctx.req.headers['x-forwarded-for'] || '';
              _idA4 = ((_ctx$req$connection = ctx.req.connection) === null || _ctx$req$connection === void 0 ? void 0 : _ctx$req$connection.remoteAddress) || '';
              _idA6 = ((_ctx$req$socket = ctx.req.socket) === null || _ctx$req$socket === void 0 ? void 0 : _ctx$req$socket.remoteAddress) || '';
              textIdA1 = "".concat(_idA2, "5").concat(_idA4, "8").concat(_idA6).replaceAll('.', '');
            } catch (error) {}
            return _context.abrupt("return", {
              seoMap: null,
              spuList: [],
              categoryList: [],
              navigationBarResponseList: [],
              globalTimestamp: ((_fetchRes = fetchRes) === null || _fetchRes === void 0 ? void 0 : _fetchRes.timestamp) || new Date().getTime(),
              gloproductlist: ((_fetchRes2 = fetchRes) === null || _fetchRes2 === void 0 ? void 0 : _fetchRes2.data) || [],
              __inwebsite__: __inwebsite__,
              headerList: headerList,
              bottomList: bottomList,
              isMobileServer: isMobileServer,
              globalLangAll: globalLangAll,
              isSupportWebp: isSupportWebp,
              hostname2: hostname2,
              gloBarObject: gloBarObject,
              isBlogPage: isBlogPage,
              textIdA1: textIdA1,
              __globar_object: __globar_object
            });
          case 76:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[22, 31], [33, 39], [42, 59], [61, 72]]);
  }));
  return function getInitialProps(_x) {
    return _ref4.apply(this, arguments);
  };
}();